import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Input } from '../../components';
import { AuthService } from '../../services';
import { LoginBanner } from '../../assets/img';
import { PasswordActive, PasswordInactive } from '../../assets/icons';
import toast from "react-hot-toast";

const Reset = () => {
  const navigate = useNavigate();
  const { code } = useParams();
  const [isVisible, setIsVisible] = useState(false);
  const [form, setForm] = useState({
    password: '',
    password_confirmation: ''
  });

  useEffect(() => {
    (async () => {
      const res = await AuthService.checkCode({ code });
      if (!res.result) {
        navigate('/', { replace: true });
      }
    })();
  }, [code, navigate]);

  const change = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  const toggleVisibility = () => {
    setIsVisible(v => !v);
  }

  const isValidForm = () => {
    const onError = (msg) => {
      toast.error(msg);
      return false;
    }

    if (!form.password)
      return onError('Debe ingresar la contraseña');

    if (String(form.password).length < 6)
      return onError('La contraseña debe tener al menos 6 caracteres');

    if (form.password !== form.password_confirmation)
      return onError('Las contraseñas no coinciden');

    return true;
  }

  const submit = async (e) => {
    e.preventDefault();

    if (!isValidForm()) return;

    try {
      await AuthService.resetPassword({
        code,
        ...form,
      });
      navigate('/success-password', { replace: true });
      toast.success('Se ha cambiado su contraseña correctamente');

    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className="flex min-h-screen w-full bg-white font-sans overflow-hidden">
      <button className="absolute top-10 left-10 text-gray-500 hover:text-gray-800 transition-colors" onClick={() => navigate('/', { replace: true })}>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
        </svg>
      </button>

      <div className="flex flex-col justify-center items-center w-full lg:w-1/2 p-8 lg:p-20">
        <form className="w-full max-w-sm flex flex-col items-center" onSubmit={submit}>
          <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            Recuperar contraseña
          </h1>

          <p className="text-gray-700 text-center text-lg mb-10 max-w-sm leading-tight">
            Ya puede crear su nueva contraseña
          </p>

          <div className="space-y-4 w-full">
            <Input
              label="Nueva contraseña"
              type={isVisible ? 'text' : 'password'}
              value={form.password}
              onValueChange={v => change(v, 'password')}
              append={
                <button
                  type="button"
                  onClick={toggleVisibility}
                  className=" text-gray-400"
                >
                  <img src={isVisible ? PasswordActive : PasswordInactive} className="w-6 h-6" alt="" />
                </button>
              }
            />

            <Input
              label="Repetir contraseña"
              type={isVisible ? 'text' : 'password'}
              value={form.password_confirmation}
              onValueChange={v => change(v, 'password_confirmation')}
              append={
                <button
                  type="button"
                  onClick={toggleVisibility}
                  className=" text-gray-400"
                >
                  <img src={isVisible ? PasswordActive : PasswordInactive} className="w-6 h-6" alt="" />
                </button>
              }
            />
          </div>

          <button className="w-full bg-red text-white font-bold py-3 rounded-2xl shadow-lg transition-colors text-xl mt-10">
            Guardar
          </button>
        </form>
      </div>

      <div className="hidden lg:flex relative w-1/2">
        <img
          src={LoginBanner}
          className="w-full h-screen object-cover"
          alt="City background"
        />
      </div>
    </div>
  )
}

export default Reset;
